var styleDataHash = 'a860f682';  
export const injectCss = (() => {
  var css = `[dir] ._3sR53>*{padding:var(--wds-space-200,12px) 0}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "dropdown": "_3sR53"
};